module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer003"
    }
  }, [_c('p', {
    staticClass: "chap-number-new"
  }, [_c('span', {
    staticClass: "poem-italic CharOverride-2"
  }, [_vm._v("Other titles from Islandport Press")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-1"
  }, [_c('span', {
    staticClass: "poem-italic CharOverride-3"
  }, [_vm._v("The Door to January")]), _c('span', {
    staticClass: "poem-italic CharOverride-4"
  }, [_vm._v(" by Gillian French")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-1"
  }, [_c('span', {
    staticClass: "poem-italic CharOverride-3"
  }, [_vm._v("The Sugar Mountain Snow Ball ")]), _c('span', {
    staticClass: "poem-italic CharOverride-4"
  }, [_vm._v("by Elizabeth Atkinson")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-1"
  }, [_c('span', {
    staticClass: "poem-italic CharOverride-3"
  }, [_vm._v("Azalea, Unschooled ")]), _c('span', {
    staticClass: "poem-italic CharOverride-4"
  }, [_vm._v("by Liza Kleinman")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-1"
  }, [_c('span', {
    staticClass: "poem-italic CharOverride-3"
  }, [_vm._v("Uncertain Glory")]), _c('span', {
    staticClass: "poem-italic CharOverride-4"
  }, [_vm._v(" by Lea Wait")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-1"
  }, [_c('span', {
    staticClass: "poem-italic CharOverride-3"
  }, [_vm._v("The Five Stones Trilogy")]), _c('span', {
    staticClass: "poem-italic CharOverride-4"
  }, [_vm._v(" by G. A. Morgan")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame _idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer004"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b07c8ed","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/what_wind_can_tell_you_interior_12_pt1.vue
// module id = 60
// module chunks = 0